import { ofType } from 'redux-observable';
import { mergeMap, map, filter, empty } from 'rxjs';
import { AppEpic } from 'src/store';
import { of } from 'rxjs';
import { updateGroupBy } from 'src/components/Subheader/Subheader.slice';
import { fetchSummaryViewData, cleanUp, receiveTenantConfig } from './SummaryView.slice';
import {
  isScopeDefined,
  isSubheaderLoaded,
  inputIsNotNullOrUndefined,
  topMemInWorklistSelected,
} from 'src/utils/Functions/epicsFunctions';
import { isNil } from 'lodash';
import {
  ConfDefnComponentType,
  SummaryViewComponent,
  maybeGetComponentProps,
  isSameComponentType,
  isWorklistActive,
} from 'src/services/configuration/codecs/confdefnComponents';
import { updateSelectedItem } from 'src/pages/Worklist/Worklist.slice';
import { isListDataApi } from 'src/services/configuration/codecs/confdefnView';
import { getAggBys, ExtraPivotOptions, organizeListDataOptions } from '../StyleColorReview.slice';
import {
  receiveScopeConfig,
  receiveScopeRefreshTrigger,
} from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { setActivePage, setActiveSubPage } from 'src/pages/NavigationShell/NavigationShell.slice';

export const summaryViewLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      receiveFilterStateAfterSubmission.type,
      setActivePage.type,
      setActiveSubPage.type,
      receiveScopeConfig.type,
      updateSelectedItem.type,
      updateGroupBy.type,
      receiveTenantConfig.type
    ),
    map(() => {
      const props = maybeGetComponentProps<SummaryViewComponent>(state$.value, ConfDefnComponentType.summaryView);
      return props;
    }),
    filter(inputIsNotNullOrUndefined),
    filter(() => topMemInWorklistSelected(state$.value)),
    filter(() => isScopeDefined(state$.value.scope) && isSubheaderLoaded(state$.value.subheader)),
    mergeMap(({ defns, topMembers }) => {
      const { dataApi, model: modelDefn } = defns;
      const finalModelDefn = isListDataApi(dataApi) ? dataApi.defnId : modelDefn;

      const aggBy = getAggBys(state$.value.subheader, dataApi);
      const options: ExtraPivotOptions =
        isWorklistActive(state$.value) && !isNil(topMembers) ? { topMembers, aggBy } : { aggBy };
      const finalOptions = organizeListDataOptions(options, dataApi);

      if (isSameComponentType<SummaryViewComponent>(state$.value, ConfDefnComponentType.summaryView)) {
        return of(cleanUp(), fetchSummaryViewData(finalModelDefn, finalOptions));
      }
      if (isWorklistActive(state$.value) && !options.topMembers) {
        // worklist views require a topMember be sent in, so don't call the pivot without it
        return empty();
      }

      return of(fetchSummaryViewData(finalModelDefn, finalOptions));
    })
  );
};
